<ng-container>
  <div>
    <div style="margin-left: 70%; margin-bottom: 2%">
      <!-- <button
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
        class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        printSectionId="print-section" ngxPrint>
        print
      </button> -->

      <button class="noPrint"
        style="margin-top: 2%; margin-left: 2%; margin-right: 2%;"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>

      <button class="noPrint" style="margin-top: 2% 2% 0 2%;"
        (click)="exportExcel('Office_Representativewise_Subscription_Report')" mat-raised-button color="primary">
        Export
      </button>
      <button mat-dialog-close class="btn noPrint">
        Close
      </button>
    </div>
  </div>
  <div>
    <div class="container" id="print-section">
      <table class="table table-bordered">
        <thead>
           <!-- <tr>
            <th *ngIf="totalth == 17" colspan="10" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 18" colspan="11" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 19" colspan="12" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 20" colspan="13" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 21" colspan="14" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 22" colspan="15" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 23" colspan="16" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 24" colspan="17" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 25" colspan="18" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 26" colspan="19" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 27" colspan="20" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 28" colspan="21" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 29" colspan="22" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 30" colspan="23" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 31" colspan="24" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 32" colspan="25" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 33" colspan="26" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 34" colspan="27" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 35" colspan="28" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 36" colspan="29" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 37" colspan="30" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 38" colspan="31" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 39" colspan="32" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 40" colspan="33" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 41" colspan="34" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 42" colspan="35" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 43" colspan="36" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 44" colspan="37" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 45" colspan="38" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 46" colspan="39" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 47" colspan="40" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 48" colspan="41" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 49" colspan="42" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
          
            <th colspan="2">दिनांक -</th>
            <th colspan="2">{{ today | date:'dd-MM-yyyy' }}</th>
             <th colspan="8"></th> 
          </tr>   -->
        
<tr>
  <!-- Title Column: dynamic colspan based on total columns -->
  <th [attr.colspan]="totalth - 13" class="largeHeading"  style="text-align: center;border-right: 1px solid white;">
    हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
  </th>
 <!-- <th style="" colspan="8"></th> -->
  <th style="border-left: 1px solid white;" colspan="8"></th>
  <!-- Date Columns -->
  <!-- <th colspan="2">दिनांक -</th>
  <th colspan="2">{{ today | date:'dd-MM-yyyy' }}</th> -->
  <th colspan="5">
  दिनांक -{{ today | date:'dd-MM-yyyy' }}</th>

  <!-- Extra spacing columns to align perfectly (adjust if needed) -->
  <!-- <th colspan="8"></th> -->
</tr>


           <!-- <tr>
            <th *ngIf="totalth == 18" colspan="11" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span>
            </th>
            <th *ngIf="totalth == 19" colspan="12" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 20" colspan="13" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 21" colspan="14" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 22" colspan="15" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 23" colspan="16" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 24" colspan="17" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 25" colspan="18" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 26" colspan="19" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 27" colspan="20" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 28" colspan="21" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 29" colspan="22" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 30" colspan="23" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span>
            </th>
            <th *ngIf="totalth == 31" colspan="24" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 32" colspan="25" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 33" colspan="26" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 34" colspan="27" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 35" colspan="28" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 36" colspan="29" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 37" colspan="30" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 38" colspan="31" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 39" colspan="32" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 40" colspan="33" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 41" colspan="34" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 42" colspan="35" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 43" colspan="36" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 44" colspan="37" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 45" colspan="38" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 46" colspan="39" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 47" colspan="40" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील -कार्यालय प्रतिनिधीनुसार</span> 
            </th>
             <th *ngIf="totalth == 48" colspan="41" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील - कार्यालय प्रतिनिधीनुसार</span> 
            </th>
            <th *ngIf="totalth == 49" colspan="42" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील - कार्यालय प्रतिनिधीनुसार</span> कार्यालय प्रतिनिधीनुसार
            </th> 
            <th colspan="2">दिनांक -</th>
            <th colspan="2">{{ startDate | date:'dd-MM-yyyy' }}</th>
            <th colspan="1">पर्यंत</th>
            <th colspan="7">{{ endDate | date:'dd-MM-yyyy' }}</th>
          </tr>  -->


     <tr>
  <!-- Report Title -->
  <th [attr.colspan]="totalth - 9" class="fontBold" style="text-align: left;">
    वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील - कार्यालय प्रतिनिधीनुसार
  </th>

  <!-- Date Range -->
  <!-- <th colspan="2">दिनांक -</th>
  <th colspan="2">{{ startDate | date: 'dd-MM-yyyy' }}</th> -->
  <!-- <th colspan="2">पर्यंत</th>
  <th colspan="3">{{ endDate | date: 'dd-MM-yyyy' }}</th> -->
  <th colspan="4">
  दिनांक -{{ startDate | date: 'dd-MM-yyyy' }}</th>
  <th colspan="5">
  पर्यंत - {{ endDate | date: 'dd-MM-yyyy' }}
</th>

</tr>


         
          <tr>
              <!-- <th style="border: 2px solid black;" rowspan="2">देश</th> -->
               <th style="border-bottom: 2px solid black; border-top: 2px solid black; border-left: 2px solid black;" rowspan="2">देश</th>

              <th style="border-bottom: 2px solid black; border-top: 2px solid black; border-left: 2px solid black;" rowspan="2">राज्य</th>
               <th style="border-bottom: 2px solid black;border-top: 2px solid black; border-left: 2px solid black;" rowspan="3">कार्यालय प्रतिनिधीचे नाव</th>
            <th style="border-bottom: 2px solid black;border-top: 2px solid black; border-left: 2px solid black;" rowspan="2">जिल्हा</th>
            <th style="border-bottom: 2px solid black; border-top: 2px solid black; border-left: 2px solid black;" rowspan="2">तालुका</th>
            <th  style="border-bottom: 2px solid black;border-bottom: 2px solid black;border-top: 2px solid black; border-left: 2px solid black;" rowspan="2">प्रतिनिधींचे नाव</th>
            <th  style="text-align: center; border-top: 2px solid black; border-left: 2px solid black; border-right: 2px solid black;" colspan="5">एकूण</th>
            <ng-container *ngFor="let data of subTypesName">
              <th style="border-top: 2px solid black;border-right: 2px solid black; "*ngIf="data.isVisible" colspan="4">{{ data.name }}</th>
                 <!-- <th *ngIf="data.isVisible" rowspan="2">रक्कम रुपये</th>    -->
            </ng-container>
          </tr>
          <tr>
            <th style="border-bottom: 2px solid black;border-left: 2px solid black;">वर्गणी दार संख्या</th>
            <th style="border-bottom: 2px solid black;">नवीन</th>
            <th style="border-bottom: 2px solid black;">नूतनीकरण</th>
            <th style="border-bottom: 2px solid black;">नूतनी-बाकी</th>
            <th style="border-bottom: 2px solid black;border-right: 2px solid black;">रक्कम</th>
            <ng-container *ngFor="let data of subTypesName">
              <th style="border-bottom: 2px solid black;border-left: 2px solid black;"*ngIf="data.isVisible"colspan="1">नवीन</th>
              <th style="border-bottom: 2px solid black;"*ngIf="data.isVisible"colspan="1">नूतनीकरण</th>
              <th style="border-bottom: 2px solid black;" *ngIf="data.isVisible"colspan="1">नूतनी-बाकी</th>
                 <th style="border-bottom: 2px solid black;;border-right: 2px solid black;" *ngIf="data.isVisible"colspan="1">रक्कम</th>   
            </ng-container>
            
          </tr>
        </thead>
        <tbody>
              <!-- <ng-container *ngFor="let item of finalData; let end=last;">
                <ng-container *ngIf="!end">
              
                  <ng-container *ngFor="let data of item; let i=index; let end1=last">
                    <tr *ngIf="!end1">
                      <td *ngIf="i == 0">{{ data['country'] }}</td>
                      <td colspan="52"></td>
                    </tr>

                    <tr *ngIf="!end1">
                      <td colspan="1"></td>
                      <td *ngIf="i == 0">{{ data['state'] }}</td>
                      <td colspan="51"></td>
                    </tr>

                    <tr *ngIf="!end1">
                      <td colspan="1"></td>
                      <td colspan="1"></td>
                      <td colspan="1" *ngIf="i == 0" style="text-align: center;">
                        {{data.office_rep_name}}
                      </td>
                      <td colspan="51"></td>
                    </tr>

                    <tr>
                      <td colspan="1"></td>
                      <td colspan="1"></td>
                      <td colspan="1"></td>
                      <td>{{ data['district'] }}</td>
              
              
                      <td>{{ data['taluka'] }}</td>
              
              
                      <td>{{ data.rep_name + '-' + data.rep_taluka }}</td>
              
                      <td>{{ data['sub'] }}</td>
                      <td>{{ data['नवीन'] }}</td>
                      <td>{{ data['नूतनीकरण'] }}</td>
                      <td>{{ data['नूतनीकरणबाकी'] }}</td>
                      <td>{{ data['एकूण'] }}</td>
                      <ng-container *ngFor="let sub of subTypesName">
                        <ng-container *ngIf="sub.isVisible">
                          <td>{{ data[getKey(sub.name)+ '_नवीन'] }}</td>
                          <td>{{ data[getKey(sub.name)+ '_नूतनीकरण']}}</td>
                          <td>{{ data[getKey(sub.name)+ '_नूतनीकरणबाकी'] }}</td>
                          <td>{{ data[getKey(sub.name)+ '_एकूण'] }}</td>
                        </ng-container>
                      </ng-container>
                    </tr>
                    <tr *ngIf="end1">
                      <td colspan="3" class="centerText">{{ data['name'] }}</td>
                      <td>{{ data['sub'] }}</td>
                      <td>{{ data['नवीन'] }}</td>
                      <td>{{ data['नूतनीकरण'] }}</td>
                      <td>{{ data['नूतनीकरणबाकी'] }}</td>
                      <td>{{ data['एकूण'] }}</td>
                      <ng-container *ngFor="let sub of subTypesName">
                        <ng-container *ngIf="sub.isVisible">
                          <td>{{ data[getKey(sub.name)+ '_नवीन'] }}</td>
                          <td>{{ data[getKey(sub.name)+ '_नूतनीकरण'] }}</td>
                          <td>{{ data[getKey(sub.name)+ '_नूतनीकरणबाकी'] }}</td>
                          <td>{{ data[getKey(sub.name)+ '_एकूण'] }}</td>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </ng-container>
              
                </ng-container>
                <ng-container *ngIf="end">
                  <tr class="smallHeading">
                    <td colspan="3">{{ item['name'] }}</td>
                    <td>{{ item['sub'] }}</td>
                    <td>{{ item['नवीन'] }}</td>
                    <td>{{ item['नूतनीकरण'] }}</td>
                    <td>{{ item['नूतनीकरणबाकी'] }}</td>
                    <td>{{ item['एकूण'] }}</td>
                    <ng-container *ngFor="let sub of subTypesName">
                      <ng-container *ngIf="sub.isVisible">
                        <td>{{ item[getKey(sub.name)+ '_नवीन'] }}</td>
                        <td>{{ item[getKey(sub.name)+ '_नूतनीकरण'] }}</td>
                        <td>{{ item[getKey(sub.name)+ '_नूतनीकरणबाकी'] }}</td>
                        <td>{{ item[getKey(sub.name)+ '_एकूण'] }}</td>
                      </ng-container>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container> -->

<!-- <ng-container *ngFor="let country of finalData; let isGroupEnd = last">
  
  <ng-container *ngIf="!isGroupEnd">
   
    <tr>
      <td style="font-weight: bold;">{{ country.country }}</td>
      <td colspan="52"></td>
    </tr>

    <ng-container *ngFor="let state of country.states">
    
      <tr>
        <td></td>
        <td style="font-weight: bold;">{{ state.state }}</td>
        <td colspan="51"></td>
      </tr>

      <ng-container *ngFor="let officeRep of state.office_reps">
        
        <tr>
          <td></td><td></td>
          <td style="text-align: center;">{{ officeRep.office_rep_name }}</td>
          <td colspan="50"></td>
        </tr>

        <ng-container *ngFor="let district of officeRep.districts">
        
          <tr>
            <td colspan="3"></td>
            <td style="font-weight: bold;">{{ data['district'] }}</td>
            <td colspan="48"></td>
          </tr>

        
          <ng-container *ngFor="let rep of district.representatives">
            <tr>
              <td colspan="5"></td>
              <td>{{ rep.rep_name }}‑{{ rep.rep_taluka }}</td>
              <td>{{ rep.total_amt }}</td>
              <td>{{ rep['नवीन'] }}</td>
              <td>{{ rep['नूतनीकरण'] }}</td>
              <td>{{ rep['नूतनीकरणबाकी'] }}</td>
              <td>{{ rep['एकूण'] }}</td>
              <ng-container *ngFor="let sub of subTypesName">
                <ng-container *ngIf="sub.isVisible">
                  <td>{{ rep[getKey(sub.name) + '_नवीन'] }}</td>
                  <td>{{ rep[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                  <td>{{ rep[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
                  <td>{{ rep[getKey(sub.name) + '_एकूण'] }}</td>
                </ng-container>
              </ng-container>
            </tr>
          </ng-container>

         
          <tr class="total-row">
            <td colspan="5" style="font-weight: bold; text-align: right;">{{ district.district }} - एकूण :</td>
            <td>{{ district.total['total_amt'] }}</td>
            <td>{{ district.total['नवीन'] }}</td>
            <td>{{ district.total['नूतनीकरण'] }}</td>
            <td>{{ district.total['नूतनीकरणबाकी'] }}</td>
            <td>{{ district.total['एकूण'] }}</td>
            <ng-container *ngFor="let sub of subTypesName">
              <ng-container *ngIf="sub.isVisible">
                <td>{{ district.total[getKey(sub.name) + '_नवीन'] }}</td>
                <td>{{ district.total[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                <td>{{ district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
                <td>{{ district.total[getKey(sub.name) + '_एकूण'] }}</td>
              </ng-container>
            </ng-container>
          </tr>
        </ng-container>

      
        <tr class="total-row">
          <td colspan="5" style="font-weight: bold; text-align: right;">{{ officeRep.office_rep_name }} - एकूण :</td>
          <td>{{ officeRep.total['total_amt'] }}</td>
          <td>{{ officeRep.total['नवीन'] }}</td>
          <td>{{ officeRep.total['नूतनीकरण'] }}</td>
          <td>{{ officeRep.total['नूतनीकरणबाकी'] }}</td>
          <td>{{ officeRep.total['एकूण'] }}</td>
          <ng-container *ngFor="let sub of subTypesName">
            <ng-container *ngIf="sub.isVisible">
              <td>{{ officeRep.total[getKey(sub.name) + '_नवीन'] }}</td>
              <td>{{ officeRep.total[getKey(sub.name) + '_नूतनीकरण'] }}</td>
              <td>{{ officeRep.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
              <td>{{ officeRep.total[getKey(sub.name) + '_एकूण'] }}</td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>
  </ng-container>

  
  <ng-container *ngIf="isGroupEnd">
    <tr class="total-row">
      <td colspan="5" style="font-weight: bold;">{{ item.name }}</td>
      <td>{{ item.total_amt }}</td>
      <td>{{ item['नवीन'] }}</td>
      <td>{{ item['नूतनीकरण'] }}</td>
      <td>{{ item['नूतनीकरणबाकी'] }}</td>
      <td>{{ item['एकूण'] }}</td>
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td>{{ item[getKey(sub.name) + '_नवीन'] }}</td>
          <td>{{ item[getKey(sub.name) + '_नूतनीकरण'] }}</td>
          <td>{{ item[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
          <td>{{ item[getKey(sub.name) + '_एकूण'] }}</td>
        </ng-container>
      </ng-container>
    </tr>
  </ng-container>
</ng-container> -->

<!-- <ng-container *ngFor="let country of finalData; let isGroupEnd = last">
  <ng-container *ngIf="!isGroupEnd">
    <tr>
      <td style="font-weight: bold;">{{ country.country }}</td>
      <td colspan="52"></td>
    </tr>

    <ng-container *ngFor="let state of country.states">
      <tr>
        <td></td>
        <td style="font-weight: bold;">{{ state.state }}</td>
        <td colspan="51"></td>
      </tr>

      <ng-container *ngFor="let officeRep of state.office_reps">
        <tr>
          <td></td><td></td>
          <td style="text-align: center;">{{ officeRep.office_rep_name }}</td>
          <td colspan="50"></td>
        </tr>

        <ng-container *ngFor="let district of officeRep.districts">
          <tr>
            <td colspan="3"></td>
            <td style="font-weight: bold;">{{ district.district_name  }}</td>
            <td colspan="48"></td>
          </tr>

          <ng-container *ngFor="let taluka of district.talukas">
            <tr>
              <td colspan="4"></td>
              <td style="font-weight: bold;">{{ taluka.taluka }}</td>
              <td colspan="47"></td>
            </tr>

            <ng-container *ngFor="let rep of taluka.representatives">
              <tr>
                <td colspan="5"></td>
                <td>{{ rep.rep_name }}‑{{ rep.rep_taluka }}</td>
                <td>{{ rep.total_amt }}</td>
                <td>{{ rep['नवीन'] }}</td>
                <td>{{ rep['नूतनीकरण'] }}</td>
                <td>{{ rep['नूतनीकरणबाकी'] }}</td>
                <td>{{ rep['एकूण'] }}</td>
                <ng-container *ngFor="let sub of subTypesName">
                  <ng-container *ngIf="sub.isVisible">
                    <td>{{ rep[getKey(sub.name) + '_नवीन'] }}</td>
                    <td>{{ rep[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                    <td>{{ rep[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
                    <td>{{ rep[getKey(sub.name) + '_एकूण'] }}</td>
                  </ng-container>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container>

        
          <tr class="total-row">
            <td colspan="5" style="text-align: right; font-weight: bold;">{{ district.district_name  }} - एकूण:</td>
            <td>{{ district.total.total_amt }}</td>
            <td>{{ district.total['नवीन'] }}</td>
            <td>{{ district.total['नूतनीकरण'] }}</td>
            <td>{{ district.total['नूतनीकरणबाकी'] }}</td>
            <td>{{ district.total['एकूण'] }}</td>
            <ng-container *ngFor="let sub of subTypesName">
              <ng-container *ngIf="sub.isVisible">
                <td>{{ district.total[getKey(sub.name) + '_नवीन'] }}</td>
                <td>{{ district.total[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                <td>{{ district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
                <td>{{ district.total[getKey(sub.name) + '_एकूण'] }}</td>
              </ng-container>
            </ng-container>
          </tr>
        </ng-container>

       
        <tr class="total-row">
          <td colspan="5" style="text-align: right; font-weight: bold;">{{ officeRep.office_rep_name }} - एकूण:</td>
          <td>{{ officeRep.total.total_amt }}</td>
          <td>{{ officeRep.total['नवीन'] }}</td>
          <td>{{ officeRep.total['नूतनीकरण'] }}</td>
          <td>{{ officeRep.total['नूतनीकरणबाकी'] }}</td>
          <td>{{ officeRep.total['एकूण'] }}</td>
          <ng-container *ngFor="let sub of subTypesName">
            <ng-container *ngIf="sub.isVisible">
              <td>{{ officeRep.total[getKey(sub.name) + '_नवीन'] }}</td>
              <td>{{ officeRep.total[getKey(sub.name) + '_नूतनीकरण'] }}</td>
              <td>{{ officeRep.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
              <td>{{ officeRep.total[getKey(sub.name) + '_एकूण'] }}</td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>
  </ng-container>
 
  <ng-container *ngIf="isGroupEnd">
    <tr class="total-row">
      <td colspan="5" style="font-weight: bold;">एकूण</td>
      <td>{{ country.total_amt }}</td>
      <td>{{ country['नवीन'] }}</td>
      <td>{{ country['नूतनीकरण'] }}</td>
      <td>{{ country['नूतनीकरणबाकी'] }}</td>
      <td>{{ country['एकूण'] }}</td>
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td>{{ country[getKey(sub.name) + '_नवीन'] }}</td>
          <td>{{ country[getKey(sub.name) + '_नूतनीकरण'] }}</td>
          <td>{{ country[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
          <td>{{ country[getKey(sub.name) + '_एकूण'] }}</td>
        </ng-container>
      </ng-container>
    </tr>
  </ng-container>
</ng-container> -->

  <!-- <ng-container *ngFor="let country of finalData; let isGroupEnd = last">
  <ng-container *ngIf="!isGroupEnd">
  
    <tr>
      <td style="font-weight: bold;">{{ country.country }}</td>
      <td colspan="52"></td>
    </tr>

    <ng-container *ngFor="let state of country.states">
    
      <tr>
        <td></td>
        <td style="font-weight: bold;">{{ state.state }}</td>
        <td colspan="51"></td>
      </tr>

      <ng-container *ngFor="let officeRep of state.office_reps">
       
        <tr>
          <td></td><td></td>
          <td style="font-weight: bold;">{{ officeRep.office_rep_name }}</td>
          <td colspan="50"></td>
        </tr>

        <ng-container *ngFor="let district of officeRep.districts">
        
          <tr>
            <td colspan="3"></td>
            <td style="font-weight: bold;">{{ district.district_name }}</td>
            <td colspan="48"></td>
          </tr>

          <ng-container *ngFor="let taluka of district.talukas">
         
            <tr>
              <td colspan="4"></td>
              <td style="font-weight: bold;">{{ taluka.taluka_name }}</td>
              <td colspan="47"></td>
            </tr>

            <ng-container *ngFor="let rep of taluka.representatives">
           
              <tr>
                <td colspan="5"></td>
                <td>{{ rep.rep_name }} – {{ rep.rep_taluka }}</td>
                <td>{{ rep.total_amt }}</td>
                <td>{{ rep['नवीन'] }}</td>
                <td>{{ rep['नूतनीकरण'] }}</td>
                <td>{{ rep['नूतनीकरणबाकी'] }}</td>
                <td>{{ rep['एकूण'] }}</td>
                <ng-container *ngFor="let sub of subTypesName">
                  <ng-container *ngIf="sub.isVisible">
                    <td>{{ rep[getKey(sub.name) + '_नवीन'] }}</td>
                    <td>{{ rep[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                    <td>{{ rep[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
                    <td>{{ rep[getKey(sub.name) + '_एकूण'] }}</td>
                  </ng-container>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container>

        
          <tr class="total-row">
            <td colspan="5" style="text-align: right; font-weight: bold;">
              {{ district.district_name }} - एकूण:
            </td>
            <td>{{ district.total.total_amt }}</td>
            <td>{{ district.total['नवीन'] }}</td>
            <td>{{ district.total['नूतनीकरण'] }}</td>
            <td>{{ district.total['नूतनीकरणबाकी'] }}</td>
            <td>{{ district.total['एकूण'] }}</td>
            <ng-container *ngFor="let sub of subTypesName">
              <ng-container *ngIf="sub.isVisible">
                <td>{{ district.total[getKey(sub.name) + '_नवीन'] }}</td>
                <td>{{ district.total[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                <td>{{ district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
                <td>{{ district.total[getKey(sub.name) + '_एकूण'] }}</td>
              </ng-container>
            </ng-container>
          </tr>
        </ng-container>

     
        <tr class="total-row">
          <td colspan="5" style="text-align: right; font-weight: bold;">
            {{ officeRep.office_rep_name }} - एकूण:
          </td>
          <td>{{ officeRep.total.total_amt }}</td>
          <td>{{ officeRep.total['नवीन'] }}</td>
          <td>{{ officeRep.total['नूतनीकरण'] }}</td>
          <td>{{ officeRep.total['नूतनीकरणबाकी'] }}</td>
          <td>{{ officeRep.total['एकूण'] }}</td>
          <ng-container *ngFor="let sub of subTypesName">
            <ng-container *ngIf="sub.isVisible">
              <td>{{ officeRep.total[getKey(sub.name) + '_नवीन'] }}</td>
              <td>{{ officeRep.total[getKey(sub.name) + '_नूतनीकरण'] }}</td>
              <td>{{ officeRep.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
              <td>{{ officeRep.total[getKey(sub.name) + '_एकूण'] }}</td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>
  </ng-container>

 
  <ng-container *ngIf="isGroupEnd">
    <tr class="total-row">
      <td colspan="5" style="font-weight: bold;">एकूण</td>
      <td>{{ country.total_amt }}</td>
      <td>{{ country['नवीन'] }}</td>
      <td>{{ country['नूतनीकरण'] }}</td>
      <td>{{ country['नूतनीकरणबाकी'] }}</td>
      <td>{{ country['एकूण'] }}</td>
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td>{{ country[getKey(sub.name) + '_नवीन'] }}</td>
          <td>{{ country[getKey(sub.name) + '_नूतनीकरण'] }}</td>
          <td>{{ country[getKey(sub.name) + '_नूतनीकरणबाकी'] }}</td>
          <td>{{ country[getKey(sub.name) + '_एकूण'] }}</td>
        </ng-container>
      </ng-container>
    </tr>
  </ng-container>
</ng-container> -->


<!-- <ng-container *ngFor="let country of finalData; let isGroupEnd = last">
  <ng-container *ngIf="!isGroupEnd">

   
    <tr>
      <td style="font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">{{ country.country }}</td>
     
          <td colspan="1"></td>
            <td colspan="1"></td>
              <td colspan="1"></td>
                <td  style=" border-right: 2px solid black;"colspan="1"></td>
                  <td  style=" border-right: 2px solid black;" colspan="1"></td>
                   <td colspan="1"></td>
            <td colspan="1"></td>
              <td colspan="1"></td>
                <td colspan="1"></td>
                  <td style=" border-right: 2px solid black;" colspan="1"></td>
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
        
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td  style=" border-right: 2px solid black;" colspan="1"></td>
        </ng-container>
      </ng-container>
    </tr>

   
     <ng-container *ngFor="let state of country.states"> 
      <tr>
        <td style=" border-left: 2px solid black;"></td>
        <td style="font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; ">{{ state.state }}</td>
      
          <td colspan="1"></td>
            <td colspan="1"></td>
              <td  style=" border-right: 2px solid black;"colspan="1"colspan="1"></td>
                <td  style=" border-right: 2px solid black;"colspan="1"></td>
                  <td colspan="1"></td>
                   <td  colspan="1"></td>
            <td colspan="1"></td>
              <td colspan="1"></td>
                <td style=" border-right: 2px solid black;" colspan="1"></td>
        <ng-container *ngFor="let sub of subTypesName">
          <ng-container *ngIf="sub.isVisible">
         
               <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td  style=" border-right: 2px solid black;"colspan="1"></td>
          </ng-container>
        </ng-container>
      </tr>

    
      <ng-container *ngFor="let officeRep of state.office_reps">
        <tr>
          <td   style=" border-left: 2px solid black;"colspan="2"></td> 
           
          <td style="font-weight: bold; border-top: 2px solid black; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">{{ officeRep.office_rep_name }}</td>
         
            <td colspan="1"></td>
            <td style=" border-right: 2px solid black;" colspan="1"></td>
              <td  style=" border-right: 2px solid black;" colspan="1"></td>
                <td colspan="1"></td>
                  <td colspan="1"></td>
                   <td colspan="1"></td>
            <td colspan="1"></td>
              <td style=" border-right: 2px solid black;"colspan="1"></td>
          <ng-container *ngFor="let sub of subTypesName">
            <ng-container *ngIf="sub.isVisible">
             
                <td colspan="1"></td>
            <td colspan="1"></td>
              <td colspan="1"></td>
               <td  style=" border-right: 2px solid black;" colspan="1"></td>
            </ng-container>
          </ng-container>
        </tr>

      
        <ng-container *ngFor="let district of officeRep.districts">
          <tr>
            <td  style=" border-left: 2px solid black;"colspan="3"></td>
            <td style="font-weight: bold;border-top: 2px solid black;border-right: 2px solid black;border-left: 2px solid black;border-bottom: 2px solid black;">{{ district.district_name }}</td>
         
             <td style=" border-right: 2px solid black;"colspan="1"></td>
            <td  style=" border-right: 2px solid black;"colspan="1"></td>
              <td colspan="1"></td>
                <td colspan="1"></td>
                  <td colspan="1"></td>
                   <td colspan="1"></td>
            <td style=" border-right: 2px solid black;"colspan="1"></td>
            <ng-container *ngFor="let sub of subTypesName">
              <ng-container *ngIf="sub.isVisible">
            
                 <td colspan="1"></td>
                  <td colspan="1"></td>
                   <td colspan="1"></td>
                    <td  style=" border-right: 2px solid black;"colspan="1"></td>
              </ng-container>
            </ng-container>
          </tr>

      
          <ng-container *ngFor="let taluka of district.talukas">
            <tr>
              <td  style=" border-left: 2px solid black;" colspan="4"></td>
              <td style="font-weight: bold;border-right: 2px solid black;border-top: 2px solid black;border-bottom: 2px solid black;border-left: 2px solid black;">{{ taluka.taluka_name }}</td>
              <td  style=" border-right: 2px solid black;" colspan="1"></td>
              <td colspan="1"></td>
                <td colspan="1"></td>
                   <td colspan="1"></td>
                    <td colspan="1"></td>
                     <td style=" border-right: 2px solid black;"colspan="1"></td>
              <ng-container *ngFor="let sub of subTypesName">
                <ng-container *ngIf="sub.isVisible">
                  <td colspan="1"></td>
                   <td colspan="1"></td>
                    <td colspan="1"></td>
                     <td  style=" border-right: 2px solid black;" colspan="1"></td>
                </ng-container>
              </ng-container>
            </tr>

         
            <ng-container *ngFor="let rep of taluka.representatives">
              <tr>
                <td colspan="5" style="border-left: 2px solid black;"></td>
                <td style="border-left: 2px solid black;border-right: 2px solid black;">{{ rep.rep_name }} – {{ rep.rep_taluka }}</td>
                <td  style="text-align: right;">{{ rep.total_amt }}</td>
                <td  style="text-align: right;">{{ rep['नवीन'] }}</td>
                <td  style="text-align: right;">{{ rep['नूतनीकरण'] }}</td>
                <td  style="text-align: right;">{{ rep['नूतनी-बाकी'] }}</td>
                <td  style="text-align: right;">{{ rep['एकूण'] }}</td>

                <ng-container *ngFor="let sub of subTypesName">
                  <ng-container *ngIf="sub.isVisible">
                    <td style="text-align: right; border-left: 2px solid black;">{{ rep[getKey(sub.name) + '_नवीन'] }}</td>
                    <td style="text-align: right;">{{ rep[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                       <td style="text-align: right;">{{ rep[getKey(sub.name) + '_नूतनी-बाकी'] }}</td>
                    <td style="text-align: right; border-right: 2px solid black;">{{ rep[getKey(sub.name) + '_एकूण'] }}</td>
                  </ng-container>
                </ng-container>
              </tr>
            </ng-container>

           
           
            <tr class="total-row">
  <td colspan="6"
      style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;
             border-left: 2px solid black; border-right: 2px solid black;text-align: right;">
    {{ district.district_name }} - एकूण:
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total.total_amt }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total['नवीन'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total['नूतनीकरण'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total['नूतनीकरणबाकी'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total['एकूण'] }}
  </td>
  <ng-container *ngFor="let sub of subTypesName">
    <ng-container *ngIf="sub.isVisible">
      <td style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ district.total[getKey(sub.name) + '_नवीन'] }}
      </td>
      <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ district.total[getKey(sub.name) + '_नूतनीकरण'] }}
      </td>
      <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}
      </td>
      <td style="font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ district.total[getKey(sub.name) + '_एकूण'] }}
      </td>
    </ng-container>
  </ng-container>
</tr>

          </ng-container>

        
        
          <tr class="total-row">
  <td colspan="6"
      style="text-align: right; font-weight: bold;
             border-top: 2px solid black; border-bottom: 2px solid black;
             border-left: 2px solid black; border-right: 2px solid black;">
    {{ officeRep.office_rep_name }} - एकूण:
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total.total_amt }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total['नवीन'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total['नूतनीकरण'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total['नूतनीकरणबाकी'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total['एकूण'] }}
  </td>
  <ng-container *ngFor="let sub of subTypesName">
    <ng-container *ngIf="sub.isVisible">
      <td style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ officeRep.total[getKey(sub.name) + '_नवीन'] }}
      </td>
      <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ officeRep.total[getKey(sub.name) + '_नूतनीकरण'] }}
      </td>
      <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ officeRep.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}
      </td>
      <td style="font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ officeRep.total[getKey(sub.name) + '_एकूण'] }}
      </td>
    </ng-container>
  </ng-container>
</tr>

        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

 
  <ng-container *ngIf="isGroupEnd">
   
 <tr class="grand-total">
  <td colspan="6"
      style="text-align: right; font-weight: bold;
             border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
    एकूण
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country.total_amt }}
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country['नवीन'] }}
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country['नूतनीकरण'] }}
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country['नूतनीकरणबाकी'] }}
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country['एकूण'] }}
  </td>
  <ng-container *ngFor="let sub of subTypesName">
    <ng-container *ngIf="sub.isVisible">
      <td style="font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ country[getKey(sub.name) + '_नवीन'] }}
      </td>
      <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
        {{ country[getKey(sub.name) + '_नूतनीकरण'] }}
      </td>
      <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
        {{ country[getKey(sub.name) + '_नूतनीकरणबाकी'] }}
      </td>
      <td style="font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ country[getKey(sub.name) + '_एकूण'] }}
      </td>
    </ng-container>
  </ng-container>
</tr>

  </ng-container>
</ng-container> -->


<ng-container *ngFor="let country of finalData; let isGroupEnd = last">
  <ng-container *ngIf="!isGroupEnd">
    
    <!-- Country Row -->
    <tr>
      <td style="font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">{{ country.country }}</td>
     
          <td colspan="1"></td>
            <td colspan="1"></td>
              <td colspan="1"></td>
                <td  style=" border-right: 2px solid black;"colspan="1"></td>
                  <td  style=" border-right: 2px solid black;" colspan="1"></td>
                   <td colspan="1"></td>
            <td colspan="1"></td>
              <td colspan="1"></td>
                <td colspan="1"></td>
                  <td style=" border-right: 2px solid black;" colspan="1"></td>
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
        
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td  style=" border-right: 2px solid black;" colspan="1"></td>
        </ng-container>
      </ng-container>
    </tr>

    <!-- States -->
    <ng-container *ngFor="let state of country.states">
      <tr>
        <td style=" border-left: 2px solid black;"></td>
        <td style="font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; ">{{ state.state }}</td>
      
          <td colspan="1"></td>
            <td colspan="1"></td>
              <td  style=" border-right: 2px solid black;"colspan="1"colspan="1"></td>
                <td  style=" border-right: 2px solid black;"colspan="1"></td>
                  <td colspan="1"></td>
                   <td  colspan="1"></td>
            <td colspan="1"></td>
              <td colspan="1"></td>
                <td style=" border-right: 2px solid black;" colspan="1"></td>
        <ng-container *ngFor="let sub of subTypesName">
          <ng-container *ngIf="sub.isVisible">
         
               <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td  style=" border-right: 2px solid black;"colspan="1"></td>
          </ng-container>
        </ng-container>
      </tr>

      <!-- Office Representatives -->
      <ng-container *ngFor="let officeRep of state.office_reps">
        <tr>
          <td   style=" border-left: 2px solid black;"colspan="2"></td> 
           
          <td style="font-weight: bold; border-top: 2px solid black; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">{{ officeRep.office_rep_name }}</td>
         
            <td colspan="1"></td>
            <td style=" border-right: 2px solid black;" colspan="1"></td>
              <td  style=" border-right: 2px solid black;" colspan="1"></td>
                <td colspan="1"></td>
                  <td colspan="1"></td>
                   <td colspan="1"></td>
            <td colspan="1"></td>
              <td style=" border-right: 2px solid black;"colspan="1"></td>
          <ng-container *ngFor="let sub of subTypesName">
            <ng-container *ngIf="sub.isVisible">
             
                <td colspan="1"></td>
            <td colspan="1"></td>
              <td colspan="1"></td>
               <td  style=" border-right: 2px solid black;" colspan="1"></td>
            </ng-container>
          </ng-container>
        </tr>


        <!-- Districts -->
        <ng-container *ngFor="let district of officeRep.districts">

          <!-- Skip total row here -->
          <ng-container *ngIf="!district.isTotalRow">
            <!-- District Row -->
           <tr>
            <td  style=" border-left: 2px solid black;"colspan="3"></td>
            <td style="font-weight: bold;border-top: 2px solid black;border-right: 2px solid black;border-left: 2px solid black;border-bottom: 2px solid black;">{{ district.district_name }}</td>
         
             <td style=" border-right: 2px solid black;"colspan="1"></td>
            <td  style=" border-right: 2px solid black;"colspan="1"></td>
              <td colspan="1"></td>
                <td colspan="1"></td>
                  <td colspan="1"></td>
                   <td colspan="1"></td>
            <td style=" border-right: 2px solid black;"colspan="1"></td>
            <ng-container *ngFor="let sub of subTypesName">
              <ng-container *ngIf="sub.isVisible">
            
                 <td colspan="1"></td>
                  <td colspan="1"></td>
                   <td colspan="1"></td>
                    <td  style=" border-right: 2px solid black;"colspan="1"></td>
              </ng-container>
            </ng-container>
          </tr>
            <!-- Talukas -->
            <ng-container *ngFor="let taluka of district.talukas">
              <tr>
              <td  style=" border-left: 2px solid black;" colspan="4"></td>
              <td style="font-weight: bold;border-right: 2px solid black;border-top: 2px solid black;border-bottom: 2px solid black;border-left: 2px solid black;">{{ taluka.taluka_name }}</td>
              <td  style=" border-right: 2px solid black;" colspan="1"></td>
              <td colspan="1"></td>
                <td colspan="1"></td>
                   <td colspan="1"></td>
                    <td colspan="1"></td>
                     <td style=" border-right: 2px solid black;"colspan="1"></td>
              <ng-container *ngFor="let sub of subTypesName">
                <ng-container *ngIf="sub.isVisible">
                  <td colspan="1"></td>
                   <td colspan="1"></td>
                    <td colspan="1"></td>
                     <td  style=" border-right: 2px solid black;" colspan="1"></td>
                </ng-container>
              </ng-container>
            </tr>

              <!-- Representatives -->
              <ng-container *ngFor="let rep of taluka.representatives">
                <tr>
                <td colspan="5" style="border-left: 2px solid black;"></td>
                <td style="border-left: 2px solid black;border-right: 2px solid black;">{{ rep.rep_name }} – {{ rep.rep_taluka }}</td>
                <td  style="text-align: right;">{{ rep.total_amt }}</td>
                <td  style="text-align: right;">{{ rep['नवीन'] }}</td>
                <td  style="text-align: right;">{{ rep['नूतनीकरण'] }}</td>
                <td  style="text-align: right;">{{ rep['नूतनी-बाकी'] }}</td>
                <td  style="text-align: right;">{{ rep['एकूण'] }}</td>

                <ng-container *ngFor="let sub of subTypesName">
                  <ng-container *ngIf="sub.isVisible">
                    <td style="text-align: right; border-left: 2px solid black;">{{ rep[getKey(sub.name) + '_नवीन'] }}</td>
                    <td style="text-align: right;">{{ rep[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                       <td style="text-align: right;">{{ rep[getKey(sub.name) + '_नूतनी-बाकी'] }}</td>
                    <td style="text-align: right; border-right: 2px solid black;">{{ rep[getKey(sub.name) + '_एकूण'] }}</td>
                  </ng-container>
                </ng-container>
              </tr>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- District Total Row -->
          <ng-container *ngIf="district.isTotalRow">
            <tr class="total-row">
  <td colspan="6"
      style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;
             border-left: 2px solid black; border-right: 2px solid black;text-align: right;">
    {{ district.district_name }} - एकूण:
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total.total_amt }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total['नवीन'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total['नूतनीकरण'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total['नूतनीकरणबाकी'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ district.total['एकूण'] }}
  </td>
  <ng-container *ngFor="let sub of subTypesName">
    <ng-container *ngIf="sub.isVisible">
      <td style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ district.total[getKey(sub.name) + '_नवीन'] }}
      </td>
      <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ district.total[getKey(sub.name) + '_नूतनीकरण'] }}
      </td>
      <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ district.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}
      </td>
      <td style="font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ district.total[getKey(sub.name) + '_एकूण'] }}
      </td>
    </ng-container>
  </ng-container>
</tr>
          </ng-container>

        </ng-container>

        <!-- Office Rep Total Row -->
        <tr class="total-row">
  <td colspan="6"
      style="text-align: right; font-weight: bold;
             border-top: 2px solid black; border-bottom: 2px solid black;
             border-left: 2px solid black; border-right: 2px solid black;">
    {{ officeRep.office_rep_name }} - एकूण:
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total.total_amt }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total['नवीन'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total['नूतनीकरण'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total['नूतनीकरणबाकी'] }}
  </td>
  <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
    {{ officeRep.total['एकूण'] }}
  </td>
  <ng-container *ngFor="let sub of subTypesName">
    <ng-container *ngIf="sub.isVisible">
      <td style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ officeRep.total[getKey(sub.name) + '_नवीन'] }}
      </td>
      <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ officeRep.total[getKey(sub.name) + '_नूतनीकरण'] }}
      </td>
      <td style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ officeRep.total[getKey(sub.name) + '_नूतनीकरणबाकी'] }}
      </td>
      <td style="font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ officeRep.total[getKey(sub.name) + '_एकूण'] }}
      </td>
    </ng-container>
  </ng-container>
</tr>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- Final Grand Total -->
  <ng-container *ngIf="isGroupEnd">
    <tr class="grand-total">
  <td colspan="6"
      style="text-align: right; font-weight: bold;
             border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
    एकूण
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country.total_amt }}
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country['नवीन'] }}
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country['नूतनीकरण'] }}
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country['नूतनीकरणबाकी'] }}
  </td>
  <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
    {{ country['एकूण'] }}
  </td>
  <ng-container *ngFor="let sub of subTypesName">
    <ng-container *ngIf="sub.isVisible">
      <td style="font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ country[getKey(sub.name) + '_नवीन'] }}
      </td>
      <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
        {{ country[getKey(sub.name) + '_नूतनीकरण'] }}
      </td>
      <td style="font-weight: bold; border-bottom: 2px solid black;text-align: right;">
        {{ country[getKey(sub.name) + '_नूतनीकरणबाकी'] }}
      </td>
      <td style="font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;text-align: right;">
        {{ country[getKey(sub.name) + '_एकूण'] }}
      </td>
    </ng-container>
  </ng-container>
</tr>

  </ng-container>
</ng-container>




  </tbody>
</table>



   

 
 

  
     


      
       
    </div>
  </div>

 
   
</ng-container>
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>
